import { t } from '@lingui/macro'
import { apolloClientPrivate } from '../../graphql/apolloClient'
import getAWSSignatureV4Form from '../../utils/getAWSSignatureV4Form'
import { axiosInstance } from '../../api/http-api'
import { notification } from '../../components/common/notifications/Notifications'
import { addTimestampToFileName } from '../../components/utils/file-upload/fileUploadCommon'

import {
  UploadCredentialsQuery,
  UploadCredentialsQueryVariables,
  UploadCredentialsDocument
} from 'front-end/src/components/utils/file-upload/operations/uploadCredentials.codegen'
import {
  LooopS3BucketEnum,
  UploadCredentials
} from 'front-end/src/graphql/private/PrivateSchemaTypes'

/**
 *  preferred upload method for all frontend needs
 */

export const LooopS3FileUpload = async ({
  S3UploadProps,
  blob,
  on
}: {
  S3UploadProps: {
    filename: string
    S3path: string
    bucket: LooopS3BucketEnum
  }
  blob: Blob
  on?: {
    uploadStart?: (
      data: { __typename?: 'UploadCredentials' } & Pick<
        UploadCredentials,
        'uploadUrl' | 'params'
      >
    ) => void
    uploadProgress?: (number) => void
    uploadComplete?: (number) => void
  }
}) => {
  S3UploadProps.filename = addTimestampToFileName(S3UploadProps.filename)
  let documentFileSize = 0

  const { data } = await apolloClientPrivate.query<
    UploadCredentialsQuery,
    UploadCredentialsQueryVariables
  >({
    variables: S3UploadProps,
    query: UploadCredentialsDocument
  })

  const { awsS3UploadCredentials } = data

  if (!awsS3UploadCredentials) {
    notification.warning(t`Unable to upload ${S3UploadProps.filename}`)
    return null
  }

  const options = {
    headers: {
      'Content-Type': blob.type
    },
    withCredentials: false,
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      on && on.uploadProgress && on.uploadProgress(percentCompleted)

      if (percentCompleted === 100) {
        documentFileSize = Math.round(progressEvent.total / Math.pow(1024, 1))
        on && on.uploadComplete && on.uploadComplete(documentFileSize)
      }
    }
  }

  on && on.uploadStart && on.uploadStart(awsS3UploadCredentials)

  const fd = getAWSSignatureV4Form(awsS3UploadCredentials.params, blob as File)
  try {
    // TODO use fetch
    await axiosInstance.post(
      awsS3UploadCredentials.uploadUrl as string,
      fd,
      options
    )

    return awsS3UploadCredentials.cdnUrl
  } catch (e) {
    console.error(e)
    notification.error(t`Image couldn't be uploaded`)
  }
}
